module.exports = __webpack_public_path__ + "src/assets/img/lumar.c2a9f6a2.png";